// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FeatureTypeDefinition } from "./FeatureTypeDefinition";
import {
  FeatureTypeDefinitionFromJSON,
  FeatureTypeDefinitionFromJSONTyped,
  FeatureTypeDefinitionToJSON,
  FeatureTypeDefinitionToJSONTyped,
} from "./FeatureTypeDefinition";
import type { Table } from "./Table";
import { TableFromJSON, TableFromJSONTyped, TableToJSON, TableToJSONTyped } from "./Table";
import type { Presentation } from "./Presentation";
import {
  PresentationFromJSON,
  PresentationFromJSONTyped,
  PresentationToJSON,
  PresentationToJSONTyped,
} from "./Presentation";

/**
 *
 * @export
 * @interface VectorUserSuppliedMeta
 */
export interface VectorUserSuppliedMeta {
  /**
   *
   */
  featureTypeDefinition?: FeatureTypeDefinition | null;
  /**
   *
   */
  styleId?: string | null;
  /**
   *
   */
  presentation?: Presentation | null;
  /**
   *
   */
  tables?: { [key: string]: Table } | null;
}

/**
 * Check if a given object implements the VectorUserSuppliedMeta interface.
 */
export function instanceOfVectorUserSuppliedMeta(value: object): value is VectorUserSuppliedMeta {
  return true;
}

export function VectorUserSuppliedMetaFromJSON(json: any): VectorUserSuppliedMeta {
  return VectorUserSuppliedMetaFromJSONTyped(json, false);
}

export function VectorUserSuppliedMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VectorUserSuppliedMeta {
  if (json == null) {
    return json;
  }
  return {
    featureTypeDefinition:
      json["feature_type_definition"] === undefined
        ? undefined
        : json["feature_type_definition"] === null
        ? null
        : FeatureTypeDefinitionFromJSON(json["feature_type_definition"]),
    styleId:
      json["style_id"] === undefined
        ? undefined
        : json["style_id"] === null
        ? null
        : json["style_id"],
    presentation:
      json["presentation"] === undefined
        ? undefined
        : json["presentation"] === null
        ? null
        : PresentationFromJSON(json["presentation"]),
    tables:
      json["tables"] === undefined
        ? undefined
        : json["tables"] === null
        ? null
        : mapValues(json["tables"], TableFromJSON),
  };
}

export function VectorUserSuppliedMetaToJSON(json: any): VectorUserSuppliedMeta {
  return VectorUserSuppliedMetaToJSONTyped(json, false);
}

export function VectorUserSuppliedMetaToJSONTyped(
  value?: VectorUserSuppliedMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    feature_type_definition: FeatureTypeDefinitionToJSON(value["featureTypeDefinition"]),
    style_id: value["styleId"],
    presentation: PresentationToJSON(value["presentation"]),
    tables: value["tables"] == null ? undefined : mapValues(value["tables"], TableToJSON),
  };
}
